import { TableCellPerColumn } from "ds/components/TableSimple/types";
import { TofuWorkspace } from "types/generated";

import { STACK_WORKSPACES_COLUMN_ID } from "../constants";
import StackWorkspacesActionsCell from "./ActionsCell";
import StackWorkspacesLockedAtCell from "./LockedAtCell";
import StackWorkspacesLockStatusCell from "./LockStatusCell";
import StackWorkspacesNameCell from "./NameCell";

const STACK_WORKSPACES_CELLS: TableCellPerColumn<TofuWorkspace> = {
  [STACK_WORKSPACES_COLUMN_ID.NAME]: StackWorkspacesNameCell,
  [STACK_WORKSPACES_COLUMN_ID.LOCK_STATUS]: StackWorkspacesLockStatusCell,
  [STACK_WORKSPACES_COLUMN_ID.LOCKED_AT]: StackWorkspacesLockedAtCell,
  [STACK_WORKSPACES_COLUMN_ID.ROW_ACTIONS]: StackWorkspacesActionsCell,
};

export default STACK_WORKSPACES_CELLS;
